<main class="app">
    <router-outlet/>
</main>

